import '../styles/app.scss'

// import external dependencies
import 'jquery';

// Import everything from autoload
// import "./autoload/_bootstrap.js"

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import properties from './routes/properties';
import singleProperty from './routes/singleProperty';
import aboutUs from './routes/about';
import whatWeDo from './routes/what-we-do';
import contact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  properties,
  singleProperty,
  whatWeDo,
  contact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
